module.exports = __webpack_public_path__ + "static/media/credit-card-icon.e8129372.svg";